
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".273","y":".093","width":"12.364","height":"24.407","rx":"1","fill":"#007EC1"}}),_c('rect',{attrs:{"x":"14.524","y":".093","width":"12.364","height":"7.845","rx":"1","fill":"#0067AD"}}),_c('rect',{attrs:{"x":"14.524","y":"9.806","width":"12.364","height":"14.694","rx":"1","fill":"#00A2AD"}})])
          )
        }
      }
    